export default "__VITE_ASSET__C7rweRz7__"